import { React, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Link, useNavigate, } from "react-router-dom";
import Addons from "../components/Addons";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import PATemplate from "../components/PlanAddonTemplate";
import Popup from "../components/Popup";
import Price from "../components/Price";
import SearchBar from "../components/SearchBar";
import { getGBussinessInfo, getGSTAddress, getGymAddonsList, getGymPlansList, getMemberOverdueCheckins, getPricingPlansById, randomTid } from "../services/apiServices.js";
import AddUsers from "./AddUsers";
import Payments from "./Payments";
import ReceiptPrint from "./ReicptPrint";
import PageError from "./PageError";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBIcon, MDBAlert,
  MDBCheckbox,
  MDBCol,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBInput

} from 'mdb-react-ui-kit';

import DatePicker from "react-datepicker";
import { renewalAleretTrans, updateTransaction } from '../services/apiServices.js'
import ClearOverdue from "./ClearOverdue";
import { useAccess } from "../context/AccessContext";


export default function HomePage(props) {
  const [plansInf, setPlansInf] = useState(JSON.parse(localStorage.getItem("planInfo")));
  useEffect(() => {
    setPlansInf(JSON.parse(localStorage.getItem("planInfo")));
  }, [localStorage.getItem("planInfo")]);
  const [startDate, setStartDate] = useState(new Date());

  console.log("startdate", startDate);

  const navigate = useNavigate();
  const [openPayment, setOpenPayment] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [uniqueId, setUniqueId] = useState(null);
  const [curIndex, setCurIndex] = useState(0);
  const [submitFlag, setsubmitFlag] = useState(0);
  const [openAddMember, setOpenAddMember] = useState(false);
  const [inputText, setInputText] = useState("");
  const [usersInfo, setUsersInfo] = useState([]);
  const [mquantity, setMquantity] = useState([]);
  const [Error2, setError2] = useState("")
  const [plansInfo, setPlans] = useState([]);
  const [loadedflag, setLoadedflag] = useState(false);
  const [selectedPlans, setSelectPlans] = useState([]);
  const [selectedAddons, setselectedAddons] = useState([]);
  const [selectPlansIds, setSelectPlansIds] = useState([]);
  const [showMainResults, setshowMainResults] = useState(false);
  const [price, setPrice] = useState(0);
  const [addons, setAddons] = useState([]);
  const [Alreadysel, setAlreadysel] = useState([]);
  const [showAddons, setshowAddons] = useState(false);
  const [data, setData] = useState("");
  const [DiscountsValues, setDiscountsValues] = useState(0);
  const [transDate, setTransDate] = useState(new Date())
  const [apiError, setApiError] = useState(false);
  const [selectAlertValue, setSelectAlertValue] = useState(false);
  const selectAlert = () => setSelectAlertValue(!selectAlertValue);
  const [selectedId, setSelectedId] = useState(null);

  const [memberDetails, setMemberDetails] = useState(null);
  const [overdueMemberIds, setOverdueMemberIds] = useState([]);



  function handleSelectItem(id) {
    setSelectedId(id);
  }
  const [showAddNameForm, setShowAddNameForm] = useState(false);
  const [openBillingAddMember, setOpenBillingAddMember] = useState(false)
  const [selectBillName, setSelectBillName] = useState({});
  const [isBillingPopupOpen, setIsBillingPopupOpen] = useState(false);
  const [selectedName, setSelectedName] = useState("");
  const [names, setNames] = useState([]);
  console.log("names", names)
  console.log(selectBillName, "selectBillName")
  console.log(selectedName);
  const [parentname, setParentName] = useState("");
  const [newName, setNewName] = useState({
    name: "",
    number: "",
    email: "",
    gstin: "",
    address: "",
  });

  const [error, setError] = useState({});
  const [selectedMember, setSelectedMember] = useState([]);
  const [renawal, setRenawal] = useState('');
  const [renewalData, setRenewalData] = useState([]);
  const [showPrevTransPopup, setShowPrevTransPopup] = useState(false);
  const [showClearOverduePopup, setShowClearOverduePopup] = useState(false);


  const addMembersToBillingList = (selectedUsers) => {
    console.log("selectedUsers", selectedUsers);
    if (selectedUsers && selectedUsers.length > 0) {
      const newMembers = selectedUsers.map(user => {
        let fullName = `${user.fname} ${user.lname}`;
        let phoneNumber = user.number;
        return {
          name: fullName,
          number: phoneNumber,
          email: user.email || "",
          gstin: "",
          address: ''
        };
      });


      const validMembers = newMembers.filter(member =>
        member.name !== "Unknown User" || member.number !== "No phone number"
      );

      if (validMembers.length === 0) {

        alert("No valid members found. Please select members with proper information.");
        return;
      }


      const uniqueNewMembers = validMembers.filter(
        newMember =>
          !names.some(existing =>
            existing.number === newMember.number ||
            (newMember.email && existing.email === newMember.email)
          )
      );
      const updatedNames = [...names, ...uniqueNewMembers];
      setNames(updatedNames);

      if (validMembers.length > 0) {
        setSelectedName(validMembers[0].name);
        // setSelectBillName(validMembers[0]);
      }

      setOpenBillingAddMember(false);

    }
  };


  // useEffect(() => {
  //   const fetchData2 = async () => {
  //     const renew = localStorage.getItem("showPrevTransPopup");
  //     const memberDetails = JSON.parse(localStorage.getItem("preadd_member"));
  //     console.log(memberDetails);
  //     // const memberId = memberDetails.
  //     const memberId = memberDetails?.member._id;
  //     console.log(memberId);
  //     const planId = memberDetails?.planId;
  //     console.log(planId);
  //     console.log(renew, memberId, planId)
  //     if (renew && !showPrevTransPopup) {
  //       try {
  //         if (!memberId || !planId) {
  //           throw new Error("Missing memberId or planId");
  //         }

  //         const updates = {
  //           memberId, planId
  //         }

  //         const response = await renewalAleretTrans(updates);

  //         if (!response) {
  //           throw new Error(`API call failed with status: ${response.status}`);
  //         }

  //         const result = await response.json();
  //         const members = Array.isArray(result) ? result : [];
  //         const membersData = members?.filter(item => {
  //           return item.members._id !== updates.memberId;
  //         });

  //         if (membersData.length > 0) {
  //           setRenewalData(membersData);
  //           setShowPrevTransPopup(true);

  //         }
  //       } catch {
  //         console.error("Error fetching data:", error);
  //       }
  //     }

  //   }
  //   fetchData2();
  // }, []);









  const checkMembersForOverdue = async (members) => {
    if (!members || members.length === 0) return [];

    const gymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
    const memberIds = members.map(m => m._id);

    try {
      const payload = { gymId, memberIds };
      const response = await getMemberOverdueCheckins(gymId, payload);
      const data = await response.json();

      if (data.success && data.groupedData?.length > 0) {
        return data.groupedData.map(item => item.memberId);
      }

      return [];
    } catch (error) {
      console.error("Error checking overdue:", error);
      return [];
    }
  };

  const handleOverdueMembers = async (members) => {
    const overdueIds = await checkMembersForOverdue(members);

    if (overdueIds.length === 0) return;

    // find ONLY new overdue members
    const newOverdueIds = overdueIds.length > 0 && overdueIds.filter(
      id => !overdueMemberIds.includes(id)
    );

    if (newOverdueIds.length > 0) {
      setOverdueMemberIds(prev => [...prev, ...newOverdueIds]);
      setShowClearOverduePopup(true);
    }
  };





  useEffect(() => {
    const fetchData2 = async () => {
      const renew = localStorage.getItem("showPrevTransPopup");
      const memberDetails = JSON.parse(localStorage.getItem("preadd_member"));
      setMemberDetails(memberDetails);

      if (renew && !showPrevTransPopup && memberDetails) {
        try {
          // ========== GET CALCULATED RENEWAL START DATE ==========
          const renewalStartDateStr = localStorage.getItem("renewalStartDate");

          if (renewalStartDateStr) {
            const renewalStartDate = new Date(renewalStartDateStr);
            setStartDate(renewalStartDate);
            console.log('Using calculated renewal start date:', renewalStartDate);
            // Show notification if backdated
            const today = new Date();
            if (renewalStartDate < today) {
              console.log('Renewal backdated due to overdue checkins');
              // You can add a toast notification here if needed
            }
          } else {
            console.log('No renewal start date calculated, using current date');
          }

          // Your existing code...
          const memberId = memberDetails?.member._id;
          const planId = memberDetails?.planId;

          if (!memberId || !planId) {
            throw new Error("Missing memberId or planId");
          }

          const updates = { memberId, planId };
          const response = await renewalAleretTrans(updates);

          if (!response) {
            throw new Error(`API call failed with status: ${response.status}`);
          }

          const result = await response.json();
          const members = Array.isArray(result) ? result : [];
          const membersData = members?.filter(item => {
            return item.members._id !== updates.memberId;
          });

          if (membersData.length > 0) {
            setRenewalData(membersData);
            setShowPrevTransPopup(true);
          }

        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData2();
  }, []);








  useEffect(() => {
    if (renewalData && renewalData.length > 0) {
      setSelectedName(renewalData[0].parentname?.name);
      setSelectBillName(renewalData[0].parentname);
    }

  }, [renewalData]);


  const toggleOpen = () => {
    setIsBillingPopupOpen(true);
  }

  const basicModalClose = () => {
    setShowAddNameForm(false);
  };


  const handleCheckboxChange = (memberDetails) => {
    setSelectedMember((prevSelected) => {
      const isSelected = prevSelected.some((m) => m._id === memberDetails._id);

      if (isSelected) {

        return prevSelected.filter((m) => m._id !== memberDetails._id);
      } else {
        return [...prevSelected, memberDetails];
      }
    });

  };







  const handleAdd = () => {

    let selItem = selItems;

    setSelItems(prevSelItems => {
      return prevSelItems.map(item => {
        const updatedQuantity = item.members.length + selectedMember.length;
        return {
          ...item,
          members: [...item.members, ...selectedMember],
          quantity: updatedQuantity,
        };

      });
    });


    if (selItems.length > 0 && selItems[0].Item) {
      const updatedPrice =
        (selItems[0].members.length + selectedMember.length) *
        selItems[0].Item.price;
      setPrice(updatedPrice);

    }




    setSelectedMember([]);
    toggleClose();

  }

  const toggleClose = () => {
    setShowPrevTransPopup(false)
    setSelectedMember([]);
  }
  const getPricingPlansBYGymid = async () => {
    const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid);
    if (!response) {
      return
    }
    if (response === "false") {
      return
    }
    const recinfo = await response.json();
    if (recinfo && recinfo.feature) {
      setPlansInf(recinfo);
      localStorage.setItem("planInfo", JSON.stringify(recinfo));
    }
  }
  useEffect(() => {

    async function fetchData() {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getGBussinessInfo(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          const record = await response.json();
          if (!record) {

            return;
          }
          setData(record);
        }
      } else {
        window.location.href = "/login"
      }
    }
    fetchData();
  }, []);
  function setSDate(date, id) {
    let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
    tselObj.idate = date;
    setStartDate(date);
  }

  function handleTransdate(date) {
    console.log("in homepage handleTransDate", date);
    setTransDate(date)
  }

  const togglePopup = (flag) => {
    // console.log("Flage :::::::::::::::: " + flag);
    switch (flag) {
      case "1":
        setOpenAddMember(!openAddMember);
        break;
      case "2":

        // console.log(openPayment);
        setOpenPayment(true);
        break;
      default:
        setOpenAddMember(!openAddMember);
    }
  };
  useEffect(() => {
    if (plansInf != null) {
      if (plansInf?.feature?.pos == false) {
        navigate('/mmanager');
        clearAll();
        return;
      }
      if (plansInf.planUsage.transactionflag == false) {
        navigate('/mmanager');
        clearAll();
        return;
      }
      if (plansInf.planUsage.activeMembflag == false) {
        navigate('/mmanager');
        clearAll();
        return;
      }
    }
  }, []);
  async function checkUserAndForward(event) {
    if (!usersInfo || usersInfo.length <= 0) {
      window.alert("To complete the transaction, at least one member must be selected.");
      // selectAlert();
    } else {
      console.log(selItems);
      let filteredData = selItems.filter((item) => !item.members || item.members.length === 0);
      if (filteredData.length > 0) {
        // selectAlert();
        window.alert("To complete the transaction, at least one member must be selected.");
      } else {
        await setState();
        setOpenPayment(true);
      }
    }
  }


  function cancelThis(event) {
    clearAll();
    setInputText("");
    getPricingPlansBYGymid();
  }


  const addOverdueObjectToSelItems = (overdueObject) => {
    console.log("Adding overdue object to selItems:", overdueObject);

    // Simply add the overdueObject to EVERY selItem
    const updatedSelItems = selItems.map(item => ({
      ...item,
      overdueData: overdueObject
    }));

    // Update state
    setSelItems(updatedSelItems);

    // Also update localStorage
    localStorage.setItem("selItems", JSON.stringify(updatedSelItems));

    console.log("Added overdue to all selItems");
  };



  function setState() {
    let tPrice = 0;
    for (const item of selItems) {
      let allMemberDiscounts = item.members && item.members.length > 0 && item.members.reduce((memberAcc, member) => memberAcc + (member.discount ? member.discount.amount : 0), 0);
      let planPrice = item.Item.price * item.quantity;
      if (item.Item.taxcheck) {
        let withoutTaxAmount = parseFloat((planPrice /
          (1 + item.taxAmount && item.taxamounts.length > 0 && item.taxamounts.reduce((acc, obj) => acc + (obj.percentage ? (parseFloat(obj.percentage) / 100) : 0), 0))).toFixed(2));
        let afterDiscount = withoutTaxAmount - allMemberDiscounts;
        tPrice = tPrice + afterDiscount + (item.taxAmount && item.taxamounts.length > 0 && item.taxamounts.reduce((acc, obj) => acc + (obj.amount ? obj.amount : 0), 0))
      } else {
        let afterDiscount = planPrice - allMemberDiscounts;
        tPrice = tPrice + afterDiscount + (item.taxamounts && item.taxamounts.length > 0 && item.taxamounts.reduce((acc, obj) => acc + (obj.amount ? obj.amount : 0), 0))
      }
      tPrice = localStorage.getItem("Tprice")
    }
    const gstobject = {
      gstin: newName.gstin,
      address: newName.address,
      name: selectBillName.name,
      number: selectBillName.number,
      email: selectBillName.email
    }

    const overdueData =
      selItems.length > 0 && selItems[0].overdueData
        ? selItems[0].overdueData
        : null;

    let allselectedData = {
      plans: selectedPlans,
      plansid: selectPlansIds,
      addons: selectedAddons,
      price: !isNaN(tPrice) ? Math.round(tPrice) : price,
      userinfo: usersInfo,
      tId: getToken(),
      totalPrice: tPrice,
      quantity: mquantity,
      transDate: transDate,
      parentname: selectBillName,
      gstobject: gstobject,
      overdueData: overdueData || null
    };
    console.log(selectBillName, 'selectBillName');


    console.log(allselectedData);
    //***********************************************************************************************************************************************************/
    localStorage.setItem("selItems", JSON.stringify(selItems));
    localStorage.setItem("allData", JSON.stringify(allselectedData));
    localStorage.setItem("gstInfo", JSON.stringify(gstobject))
    return;
  }

  function createUser() {
    setsubmitFlag(0);
    togglePopup();
  }
  function incrementCount(event, id) {
    event.preventDefault();
    let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
    if (tselObj.quantity * 1 >= 30) {
      return;
    }
    tselObj.quantity = tselObj.quantity * 1 + 1;
    if (tselObj.Item.taxcheck) {
      setPrice((Math.round(price * 1 + tselObj.Item.price * 1, 2)));
    }
    else {
      setPrice(Math.round(price * 1 + tselObj.Item.price * 1
        + (data && data.dgsttax[0] === 1 ? (((tselObj.Item.price * 1) * 0.18, 2)) : 0)
        + (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? ((tselObj.Item.price * 1) * (parseFloat(obj.label)) / 100) : 0), 0) : 0)
        , 2));
    }
  }

  function decrementCount(event, id) {
    event.preventDefault();
    let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
    tselObj.quantity = tselObj.quantity * 1 - 1;
    if (tselObj.Item.taxcheck) {
      setPrice(Math.round(price * 1 - tselObj.Item.price * 1, 2));
    }
    else {
      setPrice(Math.round(price * 1 - tselObj.Item.price * 1
        - (data && data.dgsttax[0] === 1 ? (Math.round((tselObj.Item.price * 1) * 0.18, 2)) : 0)
        - (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? Math.round((tselObj.Item.price * 1) * (parseFloat(obj.label)) / 100) : 0), 0) : 0)
        , 2));
    }
    let allMemberDiscounts = tselObj.members.reduce((memberAcc, member) => memberAcc + (member.discount ? member.discount.amount : 0), 0);
    let taxamounts = [];
    let planPrice = tselObj.Item.price * tselObj.quantity;
    if (tselObj.Item.taxcheck) {
      let withoutTaxAmount = parseFloat((planPrice / (1 + (data && data.dgsttax[0] === 1 ? 0.18 : 0)
        + (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? (parseFloat(obj.label) / 100) : 0), 0) : 0))).toFixed(2));

      let afterDiscount = withoutTaxAmount - allMemberDiscounts;

      if (data && data.dgsttax[0] === 1) {
        taxamounts.push({
          percentage: '18%',
          title: 'GST',
          amount: parseFloat((afterDiscount * 0.18).toFixed(2))
        });
      }
      if (data.ugsttax) {
        data.ugsttax.forEach((obj) => {
          if (obj.check) {
            const percentageNumber = parseFloat(obj.label);
            taxamounts.push({
              percentage: `${percentageNumber}%`,
              title: `${obj.title}`,
              amount: parseFloat((afterDiscount * (percentageNumber / 100)).toFixed(2))
            });
          }
        });
      }
      taxamounts.push({ TaxCheck: "Included" });
    } else {
      let afterDiscount = planPrice - allMemberDiscounts;

      if (data && data.dgsttax[0] === 1) {
        taxamounts.push({
          percentage: '18%',
          title: "GST",
          amount: parseFloat((afterDiscount * 0.18).toFixed(2))
        });
      }
      if (data.ugsttax) {
        data.ugsttax.forEach((obj) => {
          if (obj.check) {
            const percentageNumber = parseFloat(obj.label);
            taxamounts.push({
              percentage: `${percentageNumber}%`,
              title: `${obj.title}`,
              amount: parseFloat((afterDiscount * (percentageNumber / 100)).toFixed(2))
            });
          }
        });
      }
      taxamounts.push({ TaxCheck: "Excluded" });
    }
    tselObj.taxamounts = taxamounts;
    if (tselObj.quantity * 1 === 0) {
      let remainselItems = selItems.filter((tObj) => tObj._id !== id);
      setSelItems(remainselItems);
      localStorage.setItem("selItems", JSON.stringify(remainselItems));
      return;
    }
  }

  function Extend(objjj, id) {
    let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
    tselObj.extendmember = objjj;
  }

  function discountValues(mid, planID, dType, dEnterValue, dAmount) {
    console.log("Dicountttt", mid, planID, dType, dEnterValue, dAmount);
    try {
      let allmembers = selItems;
      let tselObj = selItems.find((tObj) => tObj._id === planID);
      console.log(tselObj);
      if (tselObj && tselObj.members && tselObj.members.length > 0) {
        const selectedMember = tselObj.members.find((tObj) => tObj._id === mid);
        if (selectedMember) {
          let value = {
            discountType: dType,
            EnterValue: Number(dEnterValue),
            amount: Number(dAmount),
          };
          console.log(value);
          selectedMember.discount = value;
        }
        let allMemberDiscounts = tselObj.members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0);
        let taxamounts = [];
        let planPrice = tselObj.Item.price * tselObj.quantity;
        if (tselObj.Item.taxcheck) {
          let withoutTaxAmount = parseFloat(
            (planPrice /
              (1 + (data && data.dgsttax[0] == 1 ? 0.18 : 0) +
                (data.ugsttax
                  ? data.ugsttax.reduce(
                    (acc, obj) => acc + (obj.check ? (parseFloat(obj.label) / 100) : 0),
                    0
                  )
                  : 0))
            ).toFixed(2)
          );
          let afterDiscount = withoutTaxAmount - allMemberDiscounts;
          if (data && data.dgsttax[0] === 1) {
            taxamounts.push({
              percentage: '18%',
              title: 'GST',
              amount: parseFloat((afterDiscount * 0.18).toFixed(2))
            });
          }

          if (data.ugsttax) {
            data.ugsttax.forEach((obj) => {
              if (obj.check) {
                const percentageNumber = parseFloat(obj.label);
                taxamounts.push({
                  percentage: `${percentageNumber}%`,
                  title: `${obj.title}`,
                  amount: parseFloat((afterDiscount * (percentageNumber / 100)).toFixed(2))
                });
              }
            });
          }

          taxamounts.push({ TaxCheck: "Included" });
          tselObj.taxamounts = taxamounts;

          const updatedSelItems = selItems.map((item) => (item._id === tselObj._id ? tselObj : item));
          console.log(updatedSelItems)
          setSelItems(updatedSelItems);
          // localStorage.setItem("selItems", JSON.stringify(updatedSelItems));
          var totalDiscountAmount_1 = allmembers.reduce((acc, item) => {
            if (item.members && item.members.length > 0) {
              return acc + item.members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0);
            } else {
              return acc;
            }
          }, 0);
          console.log(totalDiscountAmount_1);
          const dprice = parseFloat((totalDiscountAmount_1 / (1 + (data && data.dgsttax[0] === 1 ? (0.18) : 0)
            + ((data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? (parseFloat(obj.label) / 100) : 0), 0) : 0)))).toFixed(2))
          setDiscountsValues(totalDiscountAmount_1);


        } else {
          let afterDiscount = planPrice - allMemberDiscounts;
          if (data && data.dgsttax[0] === 1) {
            taxamounts.push({
              percentage: '18%',
              title: "GST",
              amount: parseFloat((afterDiscount * 0.18).toFixed(2))
            });
          }

          if (data.ugsttax) {
            data.ugsttax.forEach((obj) => {
              if (obj.check) {
                const percentageNumber = parseFloat(obj.label);
                taxamounts.push({
                  percentage: `${percentageNumber}%`,
                  title: `${obj.title}`,
                  amount: parseFloat((afterDiscount * (percentageNumber / 100)).toFixed(2))
                });
              }
            });
          }

          taxamounts.push({ TaxCheck: "Excluded" });
          tselObj.taxamounts = taxamounts;

          const updatedSelItems = selItems.map((item) => (item._id === tselObj._id ? tselObj : item));
          console.log(updatedSelItems)
          setSelItems(updatedSelItems);
          // localStorage.setItem("selItems", JSON.stringify(updatedSelItems));
          var totalDiscountAmount_2 = allmembers.reduce((acc, item) => {
            if (item.members && item.members.length > 0) {
              return acc + item.members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0);
            } else {
              return acc;
            }
          }, 0);

          setDiscountsValues(totalDiscountAmount_2);
        }
      }
    } catch (e) {
      console.error('An error occurred:', e);
      // Handle the error
    }
  }


  function taxAmounts(planObj, qty, members) {
    let taxamounts = [];
    let planPrice = planObj.price * qty;
    if (planObj.taxcheck) {

      let withoutTaxAmount = parseFloat((planPrice /
        (1 + (data && data.dgsttax[0] == 1 ? 0.18 : 0) +
          (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? (parseFloat(obj.label) / 100) : 0), 0) : 0))
      ).toFixed(2)
      );

      let allMemberDiscounts = (members && members.length > 0) ? members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0) : 0;
      let afterDiscount = withoutTaxAmount - allMemberDiscounts;

      if (data && data.dgsttax[0] === 1) {
        taxamounts.push({
          percentage: '18%',
          title: "GST",
          amount: parseFloat((afterDiscount * 0.18).toFixed(2))
        });
      }

      if (data.ugsttax) {
        data.ugsttax.forEach((obj) => {
          if (obj.check) {
            const percentageNumber = parseFloat(obj.label);
            taxamounts.push({
              percentage: `${percentageNumber}%`,
              title: `${obj.title}`,
              amount: parseFloat((afterDiscount * (percentageNumber / 100)).toFixed(2))
            });
          }
        });
      }
      taxamounts.push({ TaxCheck: "Included" });
    } else {
      let allMemberDiscounts = (members && members.length > 0) ? members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0) : 0;

      let afterDiscount = planPrice - allMemberDiscounts;

      if (data && data.dgsttax && data.dgsttax.length > 0 && data.dgsttax[0] === 1) {
        taxamounts.push({
          percentage: '18%',
          title: "GST",
          amount: parseFloat((afterDiscount * 0.18).toFixed(2))
        });
      }

      if (data.ugsttax) {
        data.ugsttax.forEach((obj) => {
          if (obj.check) {
            const percentageNumber = parseFloat(obj.label);
            taxamounts.push({
              percentage: `${percentageNumber}%`,
              title: `${obj.title}`,
              amount: parseFloat((afterDiscount * (percentageNumber / 100)).toFixed(2))
            });
          }
        });
      }
      taxamounts.push({ TaxCheck: "Excluded" });
    }
    return taxamounts;
  }
  async function addMemToLineItems(id, members, sObj, addflg) {

    console.log("984867addMemToLineItems", id, members, sObj, addflg)
    try {
      console.log("addMemToLineItems::::::::::::::::::::start")
      const renew = localStorage.getItem("showPrevTransPopup") === "true";
      if (renew && (renewalData?.length > 0) && !showPrevTransPopup) {

        setRenewalData(renawal);
        // setShowPrevTransPopup(true);
      }
      let tselItems = selItems;
      console.log(id + "," + { members });
      console.log(tselItems);
      let updatedAlreadysel = [...Alreadysel];
      let foundIndex = updatedAlreadysel.findIndex(item => item[0] === id);
      if (foundIndex !== -1) {
        updatedAlreadysel[foundIndex][1] = members;
      } else {
        updatedAlreadysel.push([id, members]);
      }
      console.log("chinaaaaaaaaaaaa%%%%%%%%%%a", updatedAlreadysel);
      setAlreadysel(updatedAlreadysel);
      let tselObj = tselItems.filter((tObj) => tObj._id === id)[0];
      if (!tselObj) {
        tselObj = sObj;
      }
      console.log(tselObj);

      tselObj.members = members;
      tselObj.quantity = members.length > 0 ? members.length : 1;
      console.log(members.length);

      const nItems = tselItems.filter((item) => item._id !== id);
      console.log(nItems);
      //**** New column in array for tax amount 
      //****Chinna --24-10-2023 ***/
      let taxamounts = taxAmounts(tselObj.Item, tselObj.quantity, tselObj?.members);
      tselObj.taxamounts = taxamounts;
      //****Chinna --Jan 16 2023 for tax calculations ***/
      tselItems = [...nItems, tselObj];
      tselItems = tselItems.sort((a, b) =>
        a.Item.name.localeCompare(b.Item.name)
      );
      // if (addflg) {
      let taddons = tselItems.filter((item) => item.isplan == "0");
      let tplans = tselItems.filter((item) => item.isplan == "1");
      console.log(taddons);
      console.log(tplans);
      if (taddons.length > 0 && tplans.length === 1) {
        let mems = tplans[0].members;
        if (mems && mems.length > 0) {
          let filterAddonMembers = taddons.filter((member) => !member.members || member.members.length === 0);
          if (filterAddonMembers.length > 0 && await window.confirm("Are you sure you want to add the selected plan member(s) to this addon?")) {
            let modifiedMembers = mems.map((member) => {
              const { discount, ...newMember } = member;
              return newMember;
            });

            taddons.forEach((taitem) => {
              console.log(taitem);
              let tamem = (taitem.members && taitem.members.length > 0) ? taitem.members : [];

              let filteMember = modifiedMembers.filter((obj) =>
                !tamem.some(modMember => modMember._id === obj._id)
              )
              if (tamem.length == 0) {
                taitem.members = modifiedMembers;
                taitem.quantity = modifiedMembers.length;
                let taxamounts = taxAmounts(taitem.Item, taitem.quantity, taitem?.members);
                taitem.taxamounts = taxamounts;
              } else {
                // taitem.members = tamem.concat(filteMember);
                // taitem.quantity = taitem.members.length;
                // let taxamounts = taxAmounts(taitem.Item, taitem.quantity);
                // taitem.taxamounts = taxamounts;
              }
              let memberAlreadysel = [...updatedAlreadysel];
              let foundIndex = memberAlreadysel.findIndex(item => item[0] === taitem.Item._id);
              if (foundIndex !== -1) {
                memberAlreadysel[foundIndex][1] = taitem.members;
              } else {
                memberAlreadysel.push([taitem.Item._id, taitem.members]);
              }
              setAlreadysel(memberAlreadysel);
            });

          }
        }
        tselItems = [...tplans, ...taddons];
      }

      if (members && members.length > 0) {
        setTimeout(() => {
          handleOverdueMembers(members);
        }, 300);
      }



      setSelItems(tselItems);
      setUsersInfo([...usersInfo, members]);
      // if (tselObj.Item.taxcheck) {
      //   setPrice(Math.round(price * 1 + tselObj.Item.price * 1, 2));
      // } else {
      //   setPrice(Math.round(price * 1 + tselObj.Item.price * 1
      //     + (data && data.dgsttax[0] === 1 ? (Math.round((tselObj.Item.price * 1) * 0.18, 2)) : 0)
      //     + (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? Math.round((tselObj.Item.price * 1) * (parseFloat(obj.label) / 100)) : 0), 0) : 0)
      //     , 2));
      // }
      let totalDiscountAmount_3 = tselItems.reduce((acc, item) => {
        if (item.members && item.members.length > 0) {
          return acc + item.members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0);
        } else {
          return acc;
        }
      }, 0);
      setDiscountsValues(totalDiscountAmount_3);
      let Totalprice = 0;
      console.log(tselItems);
      tselItems.forEach((tempItem) => {
        let tmpprice = 0;
        if (tempItem.Item.taxcheck) {
          tmpprice = Math.round(
            tmpprice * 1 + tempItem.Item.price * tempItem.quantity
          );
        } else {
          tmpprice = Math.round(
            tmpprice * 1 + Math.round(
              tempItem.Item.price * 1 +
              (data && data.dgsttax[0] === 1 ? Math.round(tempItem.Item.price * 0.18, 2) : 0) +
              (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? Math.round(tempItem.Item.price * (parseFloat(obj.label)) / 100) : 0), 0) : 0)
            ) * tempItem.quantity
          );
        }
        Totalprice += tmpprice;
      });
      if (Totalprice > 0) {
        setPrice(Totalprice);
      }
      console.log("addMemToLineItems::::::::::::::::::::Endd")
    } catch (e) { }
  }
  const [selItems, setSelItems] = useState([]);


  console.log("selItemsselItems", selItems);





  let addAddons = (eObj, id, checked) => {
    // let tselObj1 = selItems.filter((tObj) => tObj._id === id);
    // // console.log(tselObj.quantity);
    // // if (tselObj.quantity && tselObj.quantity >= 1) {
    // if (tselObj1.length === 0) {
    //   processSelect(eObj, id, checked);
    // } else {
    //   let remainselItems = selItems.filter((tObj) => tObj._id !== id);
    //   setSelItems(remainselItems);
    // }


    if (!checked) {

      let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
      console.log(tselObj);
      if (tselObj && tselObj.quantity) {
        let totalDeduction = tselObj.Item.price * tselObj.quantity;
        setPrice(Math.round(price * 1 - totalDeduction, 2));
        let remainselItems = selItems.filter((tObj) => tObj._id !== id);
        setSelItems(remainselItems);
      }
    } else {
      processSelect(eObj, id, checked);
    }
  };

  let processSelect = async (eObj, id, checked, subplan, randomId, members = []) => {
    console.log(eObj, id, checked, subplan, randomId, members, '9848675555555555555555555processselect');
    console.log("processSelect :::::::::::::::start");

    if (eObj) {
      eObj.preventDefault();
    }

    setshowMainResults(false);
    let tselItems = [...selItems]; // Create a copy
    console.log("Firstttttttt" + tselItems, tselItems.length);

    let planObj = plansInfo.length > 0 ? plansInfo.find(item => item._id === id) : null;
    console.log(planObj, 'planObj');
    let existingMembers = members;

    // Check if this is a subplan selection
    if (subplan && planObj) {
      // Find all subplans from the same base plan that are already in selItems
      const existingSubplansFromSameBase = tselItems.filter(item =>
        item.isplan === 1 &&
        planObj.subplans &&
        planObj.subplans.some(sub => sub._id === item._id)
      );

      if (existingSubplansFromSameBase.length > 0) {
        // Check if any existing subplan has the same randomId
        const sameRandomIdItem = existingSubplansFromSameBase.find(item => item.randomId === randomId);

        console.log("sameRandomIdItem", sameRandomIdItem)

        if (sameRandomIdItem) {
          // Same randomId - remove the existing subplan and continue to add new one
          existingMembers = sameRandomIdItem?.members || members


          tselItems = tselItems.filter(item => item.randomId !== randomId);
        }
      }
    }

    let tselObj = {
      quantity: existingMembers.length > 0 ? existingMembers.length : 1,
      idate: startDate,
      _id: subplan != null ? subplan : id, randomId: randomId,
      members: existingMembers
    };


    if (members && members.length > 0) {
      setTimeout(() => {
        handleOverdueMembers(members);
      }, 300);
    }



    // tselObj.Item = planObj?.subplans.find(sub => sub._id === subplan) || planObj;

    // await addMemToLineItems(subplan, existingMembers, tselObj);


    if (tselItems.filter((tObj) => tObj._id === id).length > 0) {
      tselObj = tselItems.filter((tObj) => tObj._id === id)[0];
      // tselObj.quantity = tselObj.quantity * 1 + 1;
      const nItems = tselItems.filter((item) => item._id !== id);
      // console.log(nItems);
      tselItems = [...nItems, tselObj];
      tselItems = tselItems.sort((a, b) => a.Item.name.localeCompare(b.Item.name));
      setSelItems(tselItems);

      setshowMainResults(true);
      // generateToken();
      setshowAddons(true);

      return;
    } else if (tselItems.filter((tObj) => tObj._id === subplan).length > 0) {
      tselObj = tselItems.filter((tObj) => tObj._id === subplan)[0];
      // tselObj.quantity = tselObj.quantity * 1 + 1;
      const nItems = tselItems.filter((item) => item._id !== subplan);
      // console.log(nItems);
      tselItems = [...nItems, tselObj];
      tselItems = tselItems.sort((a, b) => a.Item.name.localeCompare(b.Item.name));
      setSelItems(tselItems);

      setshowMainResults(true);
      // generateToken();
      setshowAddons(true);

      return;
    }



    console.log("*********************************************", tselObj);

    if (planObj) {
      // Check if it's a plan or a subplan
      let subplanObj = null;

      if (planObj.subplans && planObj.subplans.length > 0) {
        subplanObj = planObj.subplans.find(sub => sub._id === subplan);
      }
      console.log(subplanObj, 'subplanObj');

      if (subplanObj) {
        // If subplan exists, use it
        tselObj.Item = { ...subplanObj };
        tselObj.isplan = 1;
      } else {
        // Else fallback to plan itself
        tselObj.Item = { ...planObj };
        tselObj.isplan = 1;
      }
      tselObj.Item.randomId = randomId;
      console.log(tselObj, "tselObj");

    } else {
      // Handle addons logic (unchanged)
      try {
        let addonObj = {}
        if (addons.length > 0) {
          addonObj = addons.filter((item) => item._id === id)[0];
        } else {
          if (localStorage.getItem("loggedUserInfo")) {
            const response = await getGymAddonsList(
              JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            );
            if (response === "false") {
              setApiError(true)
            } else {
              let resp = await response.json();
              addonObj = resp.filter((item) => item._id === id)[0];
            }
          }
        }
        if (addonObj) {
          tselObj.isplan = 0;
          tselObj.Item = { ...addonObj };
          tselObj.Item.price = addonObj.price ? addonObj.price : addonObj.props[0].propvalue;
          if (!localStorage.getItem("preadd_member") && (tselItems.filter((tObj) => tObj.isplan === 1)?.length == 1)) {
            let planArray = tselItems.filter((tObj) => tObj.isplan === 1);
            let membersArray = []
            addMemToLineItems(tselObj._id, membersArray, tselObj);
          }
        }
      } catch (e) { }
    }

    console.log("tselObj?.members", tselObj);
    let taxamounts = taxAmounts(tselObj.Item, tselObj.quantity, tselObj?.members);
    tselObj.taxamounts = taxamounts;

    try {
      let tmpitems = [...tselItems, tselObj];
      tmpitems = tmpitems.sort((a, b) => a.Item.name.localeCompare(b.Item.name));
      localStorage.setItem("selItems", JSON.stringify(tmpitems));
      setSelItems(tmpitems);
      setshowMainResults(true);
      generateToken();
      setshowAddons(true);
      console.log(tmpitems, 'tmpitems');

      let totalPrice = tmpitems.length > 0 ? tmpitems.reduce((acc, item) => {
        const itemTotal = item.Item.price * item.quantity;

        if (item.Item.taxcheck) {
          return acc + Math.round(itemTotal);
        } else {
          let taxAmount = 0;

          // Add DGST tax if applicable
          if (data && data.dgsttax && data.dgsttax[0] === 1) {
            taxAmount += Math.round(itemTotal * 0.18);
          }

          // Add UGST taxes if applicable
          if (data.ugsttax) {
            taxAmount += data.ugsttax.reduce((taxAcc, obj) =>
              taxAcc + (obj.check ? Math.round(itemTotal * (parseFloat(obj.label) / 100)) : 0), 0);
          }

          return acc + Math.round(itemTotal + taxAmount);
        }
      }, 0) : 0;

      setPrice(totalPrice);
      setInputText("");
    } catch (e) { }

    let preadd = localStorage.getItem("preadd_member");
    if (preadd) {
      let preaddOBJ = JSON.parse(preadd);
      addMemToLineItems(preaddOBJ.planId, [preaddOBJ.member], tselObj);
      console.log("added member processed");
      localStorage.removeItem("preadd_member");
    }

    console.log("processSelect :::::::::::::::Enddddd");
  };
  function oncancelpayment() {
    setOpenPayment(false);
    setOpenReceipt(false);
  }
  function gotohome() {
    cancelThis();
  }

  function onSubmitUser() {
    try {
      togglePopup();
      console.log(localStorage.getItem(getToken() + "_users"));
      let tempusersInfo = localStorage.getItem(getToken() + "_users");
      let tempIndx = JSON.parse(tempusersInfo).index;

      if (!usersInfo[tempIndx]) {
        usersInfo[tempIndx] = [tempusersInfo];
      } else {
        usersInfo[tempIndx] = [...usersInfo[tempIndx], tempusersInfo];
      }

      if (mquantity[tempIndx] < usersInfo[tempIndx].length) {
        mquantity[tempIndx] = usersInfo[tempIndx].length;
      }
    } catch (e) {
      console.log("Error :::::::::::::::::::: " + e);
    }
  }

  function setToken(tTransactionId) {
    try {
      localStorage.setItem("transactionId", tTransactionId);
      setUniqueId(tTransactionId);
    } catch (e) {
      console.log("Error while creating session.. " + e);
    }
  }

  function getToken() {
    try {
      const tokenString = localStorage.getItem("transactionId");
      return tokenString;
    } catch (e) {
      console.log("error :::::: " + e);
      return;
    }
  }



  async function generateToken() {
    if (!getToken()) {
      console.log("Generating Token");

      try {
        const response = await randomTid();

        // Check if the response is valid and successful
        if (!response || !response.ok) {
          console.error("Invalid or failed response.");
          setApiError(true);
          return;
        }

        const data = await response.json();

        if (!data || data === "false") {
          setApiError(true);
          return;
        }


        const transactionId = data.id || data;

        if (transactionId) {
          console.log("Generated transactionId:", transactionId);
          setToken(transactionId);
          return;
        }
      } catch (error) {
        console.error("Error generating token:", error);
      }

      const fallbackTransactionId = Math.random().toString().substring(2, 8);
      console.log("Using fallback transactionId:", fallbackTransactionId);
      setToken(fallbackTransactionId);
    }
  }
  function showAdduser(id, event) {
    //setShowAssociateCheck((selItems.filter((item) => item.isplan == 1).length >0 && selItems.filter((item) => item.isplan == 0).length > 0 ))

    event.preventDefault();
    setCurIndex(id);
    createUser();
  }



  let inputHandler = (e) => {
    //convert input text to lower case
    e.preventDefault();

    try {
      var lowerCase = e.target.value.toLowerCase();
      setInputText(lowerCase);

    } catch (e) { }
  };

  useEffect(() => {
    if (selItems.length > 0 && plansInf != null) {
      if (plansInf.planUsage.activeMembflag && plansInf.limitation.activemembers != -1) {
        let oldcount = plansInf.planUsage.activeMemb;

        let limit = plansInf.limitation.activemembers;

        let selitems = selItems.filter((obj) => obj.Item.ptype != 1 && obj.members && obj.members.length > 0);
        let uniqueMembers = [];
        let seenIds = new Set();

        if (selitems.length > 0) {
          selitems.forEach((obj) => {
            obj.members.forEach((member) => {
              if (!seenIds.has(member._id)) {
                seenIds.add(member._id);
                uniqueMembers.push(member);
              }
            });
          });

          let newCount = uniqueMembers.length;
          let totalActiveCount = newCount + oldcount;
          if (totalActiveCount > limit) {
            deletePlanAddon(selitems[0]._id)
          }

        }
      }
    }
  }, [selItems])
  function deletePlanAddon(id) {
    let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
    if (tselObj.Item.taxcheck) {
      setPrice(Math.round(price * 1 - (tselObj.Item.price * tselObj.quantity), 2));
    }
    else {
      setPrice(Math.round(price * 1 - tselObj.Item.price * tselObj.quantity
        - (data && data.dgsttax[0] === 1 ? (Math.round((tselObj.Item.price * tselObj.quantity) * 0.18, 2)) : 0)
        - (data.ugsttax ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? Math.round((tselObj.Item.price * tselObj.quantity) * (parseFloat(obj.label)) / 100) : 0), 0) : 0)
        , 2));
    }
    let remainselItems = selItems.filter((tObj) => tObj._id !== id);
    setError2("You have reached the maximum limit of active members for this plan. Please upgrade your plan to add more active members.");
    if (remainselItems.length == 0) {
      cancelThis();
    }
    setSelItems(remainselItems);
    localStorage.setItem("selItems", JSON.stringify(remainselItems));
    return;
  }

  function selectedOptions() { }
  function onPayemntDone(event) {
    setOpenReceipt(true);
  }
  async function checkForPreAdd() {
    if (!plansInfo || plansInfo.length === 0) {
      // setSelItems([]);
      return;
    }

    let preadd = localStorage.getItem("preadd_plan");
    console.log(preadd, 'preadd');
    const memberDetails = JSON.parse(localStorage.getItem("preadd_member"));
    console.log(memberDetails);
    if (preadd) {
      let preaddOBJ = JSON.parse(preadd);
      console.log("984867preaddOBJ", preaddOBJ);

      const { planId, subplanId, member } = memberDetails;
      console.log("984867checkForPreAdd", planId, subplanId, member)
      processSelect(
        null,
        planId,
        "",
        subplanId || undefined,

      );


      addMemToLineItems(preaddOBJ.planId, [preaddOBJ.member]);

      localStorage.removeItem("preadd_plan");
    }
  }



  useEffect(() => {
    // checkForPreAdd();
    document.body.style.minHeight = "100vh";
    if (localStorage.getItem("loggedUserInfo")) {
      fetchPlans();
      fetchAddons();
    } else {
      window.location.href = "/login"
    }

    async function fetchPlans() {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getGymPlansList(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          const tempData = await response.json();
          tempData.length > 0 && tempData.forEach(plan => {
            plan.type = "plan";
          });
          if (plansInf != null && plansInf?.feature?.memebershipplans) {
            if (plansInf != null && plansInf?.feature?.planswithsessionslimit) {
              setPlans(tempData);
            } else {
              setPlans(tempData.map((obj) => {
                if (obj.subplans && obj.subplans.length > 0) {
                  return {
                    ...obj,
                    subplans: obj.subplans.filter((subplan) => !subplan.sessioncheck)
                  };
                }
                return obj;
              }).filter((obj) => {
                if (obj.subplans && obj.subplans.length > 0) {
                  return obj.subplans.length > 0;
                }
                return !obj.sessioncheck;
              }));
            }
          }
          setLoadedflag(true);
        }
      }
    }

    async function fetchAddons() {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getGymAddonsList(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          let resp = await response.json();
          if (resp && resp.length > 0) {
            let filteredResp = resp
              .map(plan => ({ ...plan, type: "addons" }))
              .filter(plan => plan.enable === true);

            if (plansInf !== null && plansInf?.feature?.addons) {
              setAddons(filteredResp);
            }
          }
        }
      }
    }

    clearAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Remove clearAll from the dependency array
  function clearAll() {
    // setItemsIndex(0);
    setMquantity([]);

    setSelectPlans([]);
    setSelectPlansIds([]);
    setPrice(0);
    setshowMainResults(false);
    setshowAddons(false);
    setUsersInfo([]);
    setselectedAddons([]);
    setSelItems([]);
    localStorage.removeItem("selItems");
    localStorage.removeItem("selectedusers");
    localStorage.removeItem(uniqueId + "_users");
    localStorage.removeItem("transactionId");
    localStorage.removeItem("allData");
    localStorage.removeItem("gstInfo")
    setOpenPayment(false);
    setOpenReceipt(false);
    setAlreadysel([]);
    //checkForPreAdd();
  }



  const activePlans = plansInfo.filter((plan) => plan?.archived !== true);


  let dateTosearch = activePlans.concat(addons);
  console.log(dateTosearch)
  useEffect(() => {
    checkForPreAdd();
  }, [data]);

  function handleDeleteMember(e, mid, planid) {

    //**** Function To remove the selected members***// 
    //****Chinna --24-10-2023 ***/ 
    const selectedItems = selItems.filter((tObj) => tObj._id !== planid);
    let remainselItems = selItems.filter((tObj) => tObj._id === planid)[0];
    const deletedMember = remainselItems?.members?.find((obj) => obj._id === mid);
    remainselItems.members = remainselItems.members.filter((obj) => obj._id !== mid);


    let allItems = [...selectedItems, remainselItems]

    var totalDiscountAmount_2 = allItems.reduce((acc, item) => {
      if (item.members && item.members.length > 0) {
        return acc + item.members.reduce((memberAcc, member) => memberAcc + (member.discount ? Number(member.discount.amount) : 0), 0);
      } else {
        return acc;
      }
    }, 0);

    setDiscountsValues(totalDiscountAmount_2);
    setSelItems([...selectedItems, remainselItems]);

    if (deletedMember) {
      const memberName = `${deletedMember.fname} ${deletedMember.lname}`;
      const updatedNames = names.filter(name =>
        !(name.name === memberName && name.number === deletedMember.number)
      );
      setNames(updatedNames);

      // Also update selectBillName if it was the deleted member
      if (selectBillName.name === memberName) {
        if (updatedNames.length > 0) {
          setSelectBillName(updatedNames[0]);
          setSelectedName(updatedNames[0].name);
        } else {
          setSelectBillName({});
          setSelectedName("");
        }
      }
    }

    let updatedAlreadysel = [...Alreadysel];
    let foundIndex = updatedAlreadysel.findIndex(item => item[0] === planid);
    if (foundIndex !== -1) {
      updatedAlreadysel[foundIndex][1] = remainselItems.members;
    } else {
      updatedAlreadysel.push([planid, remainselItems.members]);
    }
    setAlreadysel(updatedAlreadysel);
    decrementCount(e, planid)
  }

  const handleReload = () => {
    window.location.reload();
  }


  function handleDeletePlanAddon(id) {
    let deletedPlan = selItems.find(item => item._id === id);
    if (!deletedPlan) return;


    let updatedSelItems = selItems.filter(plan => plan._id !== id);

    let totalPrice = updatedSelItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    let totalTaxAmounts = updatedSelItems.flatMap(item => item.taxamounts || []);

    setSelItems(updatedSelItems.map(item => ({
      ...item,
      totalPrice,
      totalTaxAmounts
    })));

    if (deletedPlan.Item.taxcheck) {
      setPrice((prevPrice) => Math.max(prevPrice - (deletedPlan.Item.price * deletedPlan.quantity), 0));
    } else {
      setPrice(Math.round(price * 1 - deletedPlan.Item.price * deletedPlan.quantity
        - (data && data.dgsttax.length > 0 && data.dgsttax[0] === 1 ? (Math.round((deletedPlan.Item.price * deletedPlan.quantity) * 0.18, 2)) : 0)
        - (data.ugsttax && data.ugsttax.length > 0 ? data.ugsttax.reduce((acc, obj) => acc + (obj.check ? Math.round((deletedPlan.Item.price * deletedPlan.quantity) * (parseFloat(obj.label)) / 100) : 0), 0) : 0)
        , 2));
    }

  }

  const [gstError, setGSTError] = useState("")
  useEffect(() => {
    const fecthGSTAddress = async () => {
      const gstin = newName.gstin.trim();

      // GSTIN validation regex
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      if (!gstinRegex.test(gstin)) {
        console.log("Invalid GSTIN format");
        return;
      }
      const response = await getGSTAddress(gstin)
      if (!response) {
        return;
      }
      if (response === "false") {
        return
      }
      if (response === "false" || response.error) {
        setGSTError("Invalid GST Number");
        return;
      }
      const record = await response.json();
      if (!record) {
        return;
      }
      console.log(record, 'record,recordrecordrecordrecord');
      if (!record || record.error) {
        setGSTError("Invalid GST Number");
        setNewName({
          gstin: "",
          address: ""
        })
        return;
      }
      setGSTError("");

      handleInputChange({ address: record?.name + ", " + record?.businessAddress })
    }
    if (newName.gstin != "") {
      fecthGSTAddress()
    }

  }, [newName.gstin])
  function handleInputChange(value) {
    const key = Object.keys(value)[0];

    setNewName((prev) => {
      return { ...prev, ...value };
    });


    if (error[key]) {
      setError((prev) => ({ ...prev, [key]: "" }));
    }
  }


  const handlebillingclose = () => {
    setSelectedName(selectBillName.name)
    setIsBillingPopupOpen(false)

  }
  // const handleBillingNameChange = (e) => {
  //   const value = e.target.value;
  //   if (value === "add name") {
  //     toggleOpen();

  //     console.log(value);
  //   } else {
  //     const foundObject = names.find(name => name.name === value) || {};


  //     const selectedObject = {
  //       name: value,
  //       number: foundObject.number || "",
  //       email: foundObject.email || "",
  //     }
  //     setSelectBillName(selectedObject);
  //     setSelectedName(selectedObject.name);
  //     setNewName({ name: "", number: "", email: "" });
  //     console.log(value);
  //   }
  // };
  useEffect(() => {
    syncNamesWithSelItems();
    let Members = selItems;
    let selectedMembers =
      Members && Members.length > 0
        ? Members.flatMap((memberGroup) => memberGroup.members || [])
        : [];

    let membersFromSelection = selectedMembers.map((member) => ({
      name: `${member.fname} ${member.lname}`,
      number: member.number,
      email: member.email,
    }));

    console.log("membersFromSelection", membersFromSelection);

    let updatedNames = [...names];

    membersFromSelection.forEach(newMember => {
      const isDuplicate = updatedNames.some(existingMember =>
        existingMember.name === newMember.name
      );

      if (!isDuplicate) {
        updatedNames.push(newMember);
      }
    });




    const existingBillingName = updatedNames.find(
      (n) => n.name === selectBillName?.name
    );

    if (!existingBillingName) {
      if (updatedNames.length > 0) {
        const defaultName = updatedNames[0];
        setSelectBillName({
          name: defaultName.name,
          number: defaultName.number,
          email: defaultName.email,
          gstin: "",
          address: "",
        });
        setSelectedName(defaultName.name);
      } else {
        setSelectBillName({});
        setSelectedName("");
      }
    }
    if (JSON.stringify(updatedNames) !== JSON.stringify(names)) {
      setNames(updatedNames);
    }

    if (selectBillName?.name && updatedNames.length > 0) {
      const nameExists = updatedNames.some(n => n.name === selectBillName.name);

      if (!nameExists && !isBillingPopupOpen) {
        const defaultName = updatedNames[0];
        setSelectBillName({
          name: defaultName.name,
          number: defaultName.number,
          email: defaultName.email,
          gstin: "",
          address: "",
        });
        setSelectedName(defaultName.name);
      }
    }
  }, [selItems]);


  console.log(selectBillName);


  const handleSave = () => {
    const newErrors = {};

    if (!newName.name) {
      newErrors.name = "Name is required.";
    }
    if (!newName.number) {
      newErrors.number = "Mobile number is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }


    const newEntry = {
      name: newName.name,
      number: newName.number,
      email: newName.email,
      gstin: newName.gstin,
      address: newName.address,
    };


    const updatedNames = [...names, newEntry];
    setNames(updatedNames);
    setSelectBillName(newEntry);
    setSelectedName(newName.name);
    setParentName(newName.name);
    setSelectedMember(prevSelected => [...prevSelected, newEntry]);

    setNewName({ name: "", number: "", email: "", gstin: "", address: "" });

    setIsBillingPopupOpen(false);
  };

  const syncNamesWithSelItems = () => {
    const allMembers = selItems.flatMap(item =>
      item.members ? item.members.map(member => ({
        name: `${member.fname} ${member.lname}`,
        number: member.number || "",
        email: member.email || "",
        gstin: "",
        address: ""
      })) : []
    );

    const uniqueMembers = allMembers.filter((member, index, array) =>
      index === array.findIndex(m =>
        m.name === member.name && m.number === member.number
      )
    );

    setNames(uniqueMembers);
  };

  useEffect(() => {
    syncNamesWithSelItems();
  }, [selItems]);

  const { loading, handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("pointofsale")



  // Add this useEffect to update all plan start dates when startDate changes
  useEffect(() => {
    // Only update if there are selItems and startDate has changed
    if (selItems.length > 0 && startDate) {
      // Check if any selItem has a different idate
      const hasDifferentDates = selItems.some(item =>
        item.idate && new Date(item.idate).getTime() !== new Date(startDate).getTime()
      );

      if (hasDifferentDates) {
        // Update all selItems with the new startDate
        setSelItems(prevItems =>
          prevItems.map(item => ({
            ...item,
            idate: startDate
          }))
        );
      }
    }
  }, [startDate]);



  return (
    <>
      <LeftPane isactive="1" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> : <div
        className="gym-main rightContent block-container"
      >
        <SearchBar
          selItems={selItems}
          viewName="Point of Sale"
          inputText={inputText}
          inputHandler={inputHandler}
          placeholder="Search Plan/Addon"
          data={dateTosearch}
          onselect={processSelect}
          handleTransdate={handleTransdate}
          value={price}
        />

        {loadedflag && plansInfo.length === 0 && (
          <>
            No plan created yet. <Link to="/plansandaddons">Click here</Link> to
            create
          </>
        )}
        <div className="row">
          {showMainResults && (
            <div
              id="user-myBtn"
              className="col-lg-10 col-sm-12 col-md-7 g-col-8 posPlansAddons ps-2"
            >
              <div className="posplansaddonsheight ">
                {selItems.length > 0 &&
                  selItems.map((obj, index) => (
                    < >
                      <PATemplate key={index}
                        obj={obj}
                        item={obj.Item}
                        index={index}
                        quantity={obj.quantity}
                        showAdduser={showAdduser}
                        setStartDate={setSDate}
                        decrementCount={decrementCount}
                        incrementCount={incrementCount}
                        tdiscount={discountValues}
                        actualprice={obj.actualPrice}
                        onAddMembers={addMemToLineItems}
                        nonselectmem={Extend}
                        Alreadyselmem={Alreadysel}
                        hadleDeletePlan={handleDeletePlanAddon}
                        handleDeleteMember={handleDeleteMember}
                        usersInfo={obj.members}
                        selItems={selItems}
                        taxamount={obj.taxamt}
                        plansInfo={plansInfo}
                        onselect={processSelect}

                        tax={(data && (data.dgsttax[0] === 1 || (data.ugsttax && data.ugsttax.filter((obj) => obj.check === true).length > 0)))}
                      />
                    </>
                  ))}
              </div>

              {selectedAddons && selectedAddons.length > 0 && (
                <>

                  {selectedAddons.map((item, index) => (
                    <>
                      <PATemplate
                        key={index}
                        item={item}
                        obj={item}
                        index={index}
                        price={item.propvalue}
                        tdiscount={discountValues}
                        quantity={item.quantity}
                        showAdduser={showAdduser}
                        setStartDate={setSDate}
                        decrementCount={decrementCount}
                        incrementCount={incrementCount}
                        handleDeleteMember={handleDeleteMember}
                        hadleDeletePlan={handleDeletePlanAddon}
                        onAddMembers={addMemToLineItems}
                        usersInfo={item.members}
                        selItems={selItems}
                        plansInfo={plansInfo}
                        onselect={processSelect}


                      />
                    </>
                  ))}
                </>
              )}

              {showAddons && (
                <Addons
                  selItems={selItems}
                  addons={addons}
                  addonaddCallback={addAddons}
                  cancelThis={cancelThis}
                  checkUserAndForward={checkUserAndForward}
                />
              )}


            </div>

          )}
          <MDBCol>

            {showMainResults && (
              <>

                <MDBCard className="shadow-2-strong">
                  <MDBCardHeader className="d-flex align-items-center justify-content-between">
                    <b>
                      Billing Details
                    </b>
                    <MDBBtn onClick={toggleOpen}>EDIT</MDBBtn>
                  </MDBCardHeader>
                  <MDBCardBody>

                    <div className="d-flex align-items-center">
                      <p className="w-40 fw-500" >Name</p>
                      <MDBInput value={selectBillName?.name || ""} disabled />
                    </div>
                    <div className="d-flex align-items-center mt-3">
                      <p className="w-40 fw-500" >Number</p>
                      <MDBInput value={selectBillName?.number || ''} disabled />
                    </div>
                    <div className="d-flex align-items-center mt-3">
                      <p className="w-40 fw-500" >Mail</p>
                      <MDBInput value={selectBillName?.email || ''} disabled />

                    </div>
                    <div className="d-flex align-items-center mt-3">
                      <p className="w-40 fw-500" >GSTIN</p>
                      <MDBInput value={newName?.gstin || ''} disabled />

                    </div>
                    <div className="d-flex align-items-center mt-3">
                      <p className="w-40 fw-500" >Address</p>
                      <MDBInput value={newName?.address || ''} disabled />

                    </div>
                  </MDBCardBody>
                </MDBCard>
                <MDBCard className="mt-2 posTotalPrice shadow-2-strong">
                  <MDBCardHeader className="d-flex align-items-center justify-content-between">
                    <b>
                      Order Billing
                    </b>
                    {/* <p className="text-secondary m-0">
                    <DatePicker
                      selected={startDate}
                      dateFormat="MM-dd-yyyy"
                      className="inp-clrdate-Small"
                      onChange={(date) => selectedId && setSDate(date, selectedId)}
                    />
                  </p> */}
                  </MDBCardHeader>
                  <MDBCardBody>
                    <Price Discounts={DiscountsValues} price={price} obj={selItems} addonaddCallback={addAddons}
                      cancelThis={cancelThis}
                      checkUserAndForward={checkUserAndForward}
                      plansInfo={plansInfo} />

                  </MDBCardBody>
                </MDBCard>
              </>
            )}

          </MDBCol>
        </div>
        {openAddMember && (
          <>
            <MDBModal open={openAddMember} onClose={() => setOpenAddMember(false)} tabIndex='-1'>
              <MDBModalDialog size="lg">
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Add Member(s)</MDBModalTitle>
                    <MDBBtn className='btn-close' color='none' onClick={togglePopup}></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <AddUsers
                      id={getToken()}
                      index={curIndex}
                      onsubmit={onSubmitUser}
                      submit={submitFlag}
                      onAdd={addMemToLineItems}
                      plansInfo={plansInfo}
                    />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>


          </>
        )}
        {openPayment && (
          <Popup
            title="Payment Information"
            ptype="modal-lg"
            from="transactions"
            content={
              <>
                <div>
                  <Payments
                    onselect={selectedOptions}
                    onsubmit={onPayemntDone}
                    oncancel={oncancelpayment}
                    onhome={gotohome}

                    // discount={discount}
                    Discounts={DiscountsValues}
                    obj={selItems}
                  />
                </div>
              </>
            }
            handleClose={oncancelpayment}
          />
        )}
        {openReceipt && (
          <Popup
            title="Print Receipt"
            from="transactions"
            ptype="modal-lg"
            content={
              <>
                <div>
                  <ReceiptPrint gotohome={gotohome} discount={DiscountsValues} plansInfo={plansInfo} />
                </div>
              </>
            }
            handleClose={() => handleReload()}
          />
        )}


        {isBillingPopupOpen && (
          <>
            <MDBModal open={isBillingPopupOpen} onClose={() => setIsBillingPopupOpen(false)} tabIndex='0'  >
              <MDBModalDialog>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Edit Billing Details</MDBModalTitle>
                    <MDBBtn className='btn-close' color='none' onClick={() => setIsBillingPopupOpen(false)}></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <b>Billing Name</b>

                    <ol className="ms-3 mt-2">
                      {names.length > 0 ? (
                        names.map((obj, index) => (
                          <li key={index} className="d-flex align-items-center mb-2">
                            <input
                              type="radio"
                              name="billingName"
                              value={obj.name}
                              checked={selectedName === obj.name}
                              onChange={() => setSelectedName(obj.name)}
                              className="me-2"
                            />
                            {obj.name && obj.name !== "undefined undefined" ? obj.name : "Unknown"},
                            {obj.number && obj.number !== "undefined" ? obj.number : "No phone number"}
                          </li>
                        ))
                      ) : (
                        <li>No billing names available. Please add a billing name.</li>
                      )}
                    </ol>

                    <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
                      <MDBBtn
                        onClick={() => {
                          setOpenBillingAddMember(true);
                          setShowAddNameForm(false)
                        }}
                        style={{ cursor: 'pointer', color: '#007bff' }}
                      >
                        Add Name from the system
                      </MDBBtn>

                      <MDBBtn onClick={() => setShowAddNameForm(true)} style={{ cursor: 'pointer', color: '#007bff' }}>
                        Add New Billing Name
                      </MDBBtn>
                    </div>

                    {showAddNameForm && (
                      <>
                        <div className="mb-3 d-flex align-items-center justify-content-between ">
                          <label className="fw-bold"> Name:<span className="text-danger">*</span></label> <label className="fw-600">
                            <input
                              className="form-control"
                              type="text"
                              name="name"
                              placeholder="Name"
                              value={newName.name}

                              onChange={(e) => handleInputChange({ name: e.target.value })}

                            />
                            {error.name && <p className="clr-red">{error.name}</p>}
                          </label>
                        </div>
                        <div className="mb-3 d-flex align-items-center justify-content-between">
                          <label className="fw-bold"> Mobile Number:<span className="text-danger">*</span></label> <label className="fw-600">
                            <input
                              className="form-control"
                              type="number"
                              name="mobile"
                              placeholder="Mobile No"
                              value={newName.number}

                              onChange={(e) => handleInputChange({ number: e.target.value })}
                            />
                            {error.number && <p className="clr-red">{error.number}</p>}
                          </label>
                        </div>
                        <div className="mb-3 d-flex align-items-center justify-content-between">
                          <label className="fw-bold"> Email:</label> <label className="fw-600">
                            <input
                              className="form-control"
                              type="email"
                              name="email"
                              placeholder="Email"
                              value={newName.email}
                              onChange={(e) => handleInputChange({ email: e.target.value })}
                            />
                          </label>
                        </div>
                        <div className="pe-3 pb-2 mt-3 d-flex justify-content-end gap-2">

                          <MDBBtn color='secondary' onClick={() => basicModalClose()}>
                            Close
                          </MDBBtn>
                          <MDBBtn onClick={handleSave}>Save</MDBBtn>
                        </div>
                      </>
                    )}




                    {openBillingAddMember && (
                      <MDBModal open={openBillingAddMember} onClose={() => setOpenBillingAddMember(false)} tabIndex='-1'>
                        <MDBModalDialog size="lg">
                          <MDBModalContent>
                            <MDBModalHeader>
                              <MDBModalTitle>Add Member(s)</MDBModalTitle>
                              <MDBBtn className='btn-close' color='none' onClick={() => setOpenBillingAddMember(false)}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                              <AddUsers
                                id={getToken()}
                                index={curIndex}
                                onsubmit={onSubmitUser}
                                submit={submitFlag}
                                onAdd={addMembersToBillingList}
                                plansInfo={plansInfo}
                              />
                            </MDBModalBody>
                          </MDBModalContent>
                        </MDBModalDialog>
                      </MDBModal>
                    )}

                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <label className="fw-bold w-30"> GSTIN:</label>
                      <input
                        className="form-control flex-grow-1"
                        type="text"
                        name="gstin"
                        placeholder="gstin"
                        value={newName.gstin}
                        onChange={(e) => handleInputChange({ gstin: e.target.value })}
                      />

                    </div>
                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <label className="fw-bold w-30">Address:</label>
                      {/* <input
                          className="form-control"
                          type="text"
                          // name="gstin"
                          // placeholder="gstin"
                          value={newName.address}
                        // onChange={(e) => handleInputChange({ address: e.target.value })}
                        /> */}
                      {/* {newName.address} */}
                      <textarea className="form-control flex-grow-1" value={newName.address}></textarea>

                    </div>


                    <MDBModalFooter className="mt-3 d-flex justify-content-end gap-2" >
                      <MDBBtn
                        size="sm"
                        color='secondary'
                        onClick={() =>
                          handlebillingclose()
                        }

                      >
                        Close
                      </MDBBtn>
                      <MDBBtn
                        size="sm"
                        color="primary"
                        onClick={() => {

                          const selectedObj = names.find((n) => n.name === selectedName);
                          console.log(selectedObj, 'selectedObjselectedObj');

                          if (selectedObj) setSelectBillName(selectedObj);

                          setIsBillingPopupOpen(false)

                        }}
                        disabled={!selectedName}
                      >
                        Save Selected
                      </MDBBtn>
                    </MDBModalFooter>


                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

          </>

        )}



        {(renewalData.length > 0) && showPrevTransPopup && (
          <Popup
            title={<h3 className="gym-xlarge">Prevoius Transactions Members</h3>}
            content={
              <>
                <div>
                  <h5 className="gym-xlarge"> Would you like to add lastest transaction members</h5>
                  {renewalData?.map((item, index) => (

                    <MDBCheckbox
                      name="flexCheck"
                      onChange={() => handleCheckboxChange(item.members)}
                      value=""
                      id={item.members._id}
                      // label={`${item.members.fname} ${item.members.lname} ${item.members.number && <>,</>} ${item.members.number}`}
                      label={`${item.members.fname} ${item.members.lname}${item.members.number ? `, ${item.members.number}` : ''}`}
                    />

                  ))

                  }
                </div>
                <MDBModalFooter className="pe-3 pb-2">
                  <MDBBtn color='secondary' onClick={() => toggleClose()}>
                    cancel
                  </MDBBtn>
                  <MDBBtn onClick={handleAdd}>ADD</MDBBtn>
                </MDBModalFooter>
              </>
            }
            handleClose={toggleClose}
          />
        )}

        <MDBModal tabIndex='-1' open={selectAlertValue} onClose={() => setSelectAlertValue(false)}>
          <MDBModalDialog centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>  <MDBIcon fas icon="exclamation-triangle" className="me-3 fs-5 mt-1" color="warning" />Alert</MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={selectAlert}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                To complete the transaction, at least one member must be selected
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn className="me-3 mb-3" color='secondary' onClick={selectAlert}>
                  Close
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

      </div>}
      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Error2 != ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>
      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={gstError != ""}
        onClose={() => setGSTError("")}
      >
        {gstError}
      </MDBAlert>








      {showClearOverduePopup && (
        <Popup
          title={<h3 className="gym-xlarge">Overdue Checkins</h3>}
          ptype="modal-lg"
          content={
            <>
              <ClearOverdue
                memberIds={overdueMemberIds}
                // memberName={`${memberDetails.member.fname} ${memberDetails.member.lname}`}
                gymId={JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid}
                onClose={() => {
                  console.log("Write-off completed");
                  setShowClearOverduePopup(false);
                }}
                // onStartDateSelected={(selectedDate) => {
                //   const parsedDate = new Date(selectedDate);
                //   const now = new Date();

                //   const newStartDate = new Date(
                //     parsedDate.getFullYear(),
                //     parsedDate.getMonth(),
                //     parsedDate.getDate(),
                //     now.getHours(),
                //     now.getMinutes(),
                //     now.getSeconds()
                //   );

                //   setSelItems(prevItems =>
                //     prevItems.map(item => ({
                //       ...item,
                //       idate: newStartDate
                //     }))
                //   );

                //   setStartDate(newStartDate);
                //   setShowClearOverduePopup(false);
                // }}

                onStartDateSelected={(overdueObject) => {
                  // ONE LINE: Add overdue object to selItems
                  addOverdueObjectToSelItems(overdueObject);
                  setShowClearOverduePopup(false);
                }}

              />
            </>
          }
          handleClose={() => setShowClearOverduePopup(false)}
        />
      )}


    </>
  );
}
